'use client';

import { Typography } from '@unity/cloud-ui';

export const ListItem = (props) => {
  return <Typography component="li" variant="body1" sx={{ '&>div': { pb: 1 } }} {...props} />;
};
